<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { warehouseMethods } from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Bodegas',
  page: {
    title: 'Bodegas',
    meta: [{ name: 'Bodegas', content: 'Bodegas' }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Bodegas',
      items: [
        {
          text: 'Bodegas',
          active: true,
        },
      ],
      warehouse: [],
      pageoptions: [1, 3, 5, 10, 15],
      /* ------------- list warehouse pag ------------- */
      paginaActual: 1,
      itemsPorPagina: 5,
      /* --------------list ubication pag------------------*/
      paginaActual_u: 1,
      itemsPorPagina_u: 5,
      /* -----------------------------------------*/
      warehouse_selected: null,
      ubication_selected: null,
    }
  },
  computed: {
    ...mapGetters({
      loading_warehouses: 'retina/warehouse/loading_warehouses',
    }),
    infoOptionSelected() {
      this.ubication_selected = null
      let whs = this.warehouse.results.find(
        (wh) => wh.id === this.warehouse_selected
      )
      let nwhs = JSON.parse(JSON.stringify(whs))
      delete nwhs.ubications
      delete nwhs.id
      return nwhs
    },
    infoUbicationOptionSelected() {
      let options_ubications = []

      let whs = this.warehouse.results.find(
        (wh) => wh.id === this.warehouse_selected
      )
      let ub = whs.ubications

      if (ub.length == 0) {
        options_ubications.push({
          value: whs.id,
          text: whs.description,
        })
      } else {
        ub.forEach((u) => {
          options_ubications.push({
            value: u.id,
            text: u.name,
          })
        })
      }

      return options_ubications
    },
  },
  methods: {
    ...warehouseMethods,
    allWarehouse() {
      this.setLoadingWarehouses(true)
      return this.fetchWarehouses('')
        .then((data) => {
          this.warehouse = data
          this.setLoadingWarehouses(false)
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          this.setLoadingWarehouses(false)
          return []
        })
    },
    paginador(items) {
      const indiceInicio = (this.paginaActual - 1) * this.itemsPorPagina
      const indiceFinal =
        indiceInicio + this.itemsPorPagina > items.length
          ? items.length
          : indiceInicio + this.itemsPorPagina
      return items.slice(indiceInicio, indiceFinal)
    },
    paginador_u(items) {
      const indiceInicio = (this.paginaActual_u - 1) * this.itemsPorPagina_u
      const indiceFinal =
        indiceInicio + this.itemsPorPagina_u > items.length
          ? items.length
          : indiceInicio + this.itemsPorPagina_u
      return items.slice(indiceInicio, indiceFinal)
    },
    selectWarehouse(id) {
      this.warehouse_selected = id
    },
    selectUbication(id) {
      this.ubication_selected = id
    },
  },
  mounted() {
    this.allWarehouse()
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-card>
      <div class="d-flex align-items-center" v-if="loading_warehouses">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
        <h4>Cargando Lista de Bodegas</h4>
      </div>
      <div v-if="!loading_warehouses" class="row">
        <div class="col-xl-4">
          <h4 class="mb-3">Lista de Bodegas</h4>
          <div class="mb-4">
            <span class="ml-2">Bodegas por página: </span>
            <b-form-select
              v-model="itemsPorPagina"
              size="sm"
              :options="pageoptions"
              class="w-25 mr-2"
            ></b-form-select>
          </div>
          <b-list-group>
            <b-list-group-item
              button
              @click="selectWarehouse(item.id)"
              class="flex-column align-items-start"
              v-for="item in paginador(warehouse.results)"
              :key="item.id"
              :active="warehouse_selected == item.id"
            >
              <div class="d-flex w-100 justify-content-between">
                <div>
                  <p class="mb-0 lead">
                    {{ item.description }}
                    <b-badge variant="primary">{{ item.code }}</b-badge>
                  </p>
                  <p class="mb-0">{{ item.company }}</p>
                  <small>{{ item.nit }}</small>
                </div>
                <small>
                  <div class="text-right font-italic text-info">
                    {{ item.multi_ubication }}
                  </div>
                  <div class="text-right">
                    <b-badge
                      v-if="item.multi_ubication == 'Varias Ubicaciones'"
                      variant="info"
                    >
                      {{ item.ubications.length }}
                    </b-badge>
                  </div>
                </small>
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-pagination
            class="mt-2"
            align="left"
            :total-rows="this.warehouse.results.length"
            v-model="paginaActual"
            :per-page="itemsPorPagina"
          ></b-pagination>
          <span style="color: #F28C02">
          Mostrando
          {{
            !warehouse.results.length
              ? 0
              : (paginaActual - 1) * itemsPorPagina + 1
          }}
          -
          {{
            !warehouse.results.length
              ? 0
              : paginaActual * itemsPorPagina >= warehouse.results.length
              ? warehouse.results.length
              : paginaActual * itemsPorPagina
          }}
          de {{ warehouse.results.length }}</span>
        </div>

        <div class="col-xl-4">
          <h4 class="mb-3">Ubicaciones</h4>
          <div class="mb-4">
            <span class="ml-2">Ubicaciones por página: </span>
            <b-form-select
              v-model="itemsPorPagina_u"
              size="sm"
              :options="pageoptions"
              class="w-25 mr-2"
            ></b-form-select>
          </div>
          <div v-if="warehouse_selected">
            <h5>
              {{ infoOptionSelected.description }}
              <b-badge variant="primary">{{ infoOptionSelected.code }}</b-badge>
            </h5>
            <b-list-group>
              <b-list-group-item
                @click="selectUbication(ub.value)"
                button
                v-for="ub in paginador_u(infoUbicationOptionSelected)"
                :key="ub.value"
                :active="ubication_selected == ub.value"
              >
                {{ ub.text }}
              </b-list-group-item>
            </b-list-group>
            <b-pagination
              class="mt-2"
              align="left"
              :total-rows="this.infoUbicationOptionSelected.length"
              v-model="paginaActual_u"
              :per-page="itemsPorPagina_u"
            ></b-pagination>
            <span style="color: #F28C02">
              Mostrando 
            {{
              !infoUbicationOptionSelected.length
                ? 0
                : (paginaActual_u - 1) * itemsPorPagina_u + 1
            }}
            -
            {{
              !infoUbicationOptionSelected.length
                ? 0
                : paginaActual_u * itemsPorPagina_u >=
                  infoUbicationOptionSelected.length
                ? infoUbicationOptionSelected.length
                : paginaActual_u * itemsPorPagina_u
            }}
            de {{ infoUbicationOptionSelected.length }}
            </span>
            <div class="mt-3">
              Bodega Seleccionada:
              <strong>id: {{ warehouse_selected }} </strong>
              <strong>{{ infoOptionSelected.code }}</strong>
            </div>
            <div>
              Ubicación Seleccionada:
              <strong>{{
                ubication_selected ? ubication_selected : ''
              }}</strong></div
            >
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>
